import './delete-modal-container.component.scss';

import { memo, useMemo } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

import ModalContainer from '../ModalContainer';
import Icon from '../Icon';
import LinkerWithA from '../LinkerWithA';

const DefaultResultChildren = props => {
  const { t } = useTranslation();
  const { title, results, onDownload, thList } = props;
  const newResults = useMemo(() => {
    const requriedStatusTypeList = results.map(({ requriedStatusType, ...other }) => requriedStatusType);
    const cleanResults = results.map(({ requriedStatusType, ...other }) => other);
    const tdList = cleanResults.map(item => Object.values(item));
    return { thList, tdList, requriedStatusTypeList };
  }, [results, thList]);

  return (
    <>
      <div className='header'>
        <div className='title'>{t(title)}</div>
      </div>
      <div className='body'>
        <div className='d-flex justify-content-end mb-2'>
          <Icon
            iconTitle={t('801ab24683')} // Download
            className="icon-download"
            style={{ width: 21, height: 21 }}
            onClick={onDownload}
          />
        </div>
        <Table responsive striped hover className="table-container">
          <thead>
            <tr>
              {
                newResults.thList.map((label, index) => {
                  return (
                    <th key={'result-modal-th-' + index}>
                      <LinkerWithA label={t(label)} className="text-decoration-none is-sort-off" />
                    </th>
                  );
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              newResults?.tdList?.map((itemList, index) => {
                const isFailed = newResults.requriedStatusTypeList[index] === 'error';
                return (
                  <tr key={'result-modal-tbody-tr-' + index}>
                    {
                      itemList.map((item, index) => {
                        return (
                          <td key={'result-modal-tbody-td-' + index}>
                            <span className={isFailed ? 'failed-word' : ''}>{t(item)}</span>
                          </td>
                        );
                      })
                    }
                  </tr>
                );
              })
            }
          </tbody>
        </Table>
      </div>
    </>
  );
};

const ResultModalContainer = props => {
  const {
    modalWidthType,
    thList,
    title,
    results,
    openModal,
    closeModal,
    onDownload,
  } = props;

  const currentTitle = title || 'a22aad1565'; // Result

  return (
    <ModalContainer
      openModal={openModal}
      modalWidthType={modalWidthType}
      closeModal={closeModal}
      children={
        <DefaultResultChildren
          thList={thList}
          title={currentTitle}
          results={results}
          closeModal={closeModal}
          onDownload={onDownload}
        />
      }
    />
  );
};

ResultModalContainer.defaultProps = {
  thList: [],
  tdList: [],
  requriedStatusTypeList: []
}

export default memo(ResultModalContainer);

// Rules :
// 1. The 'th' would generated from 'thList.
// 2. The 'td' and its' info would generated from value of 'results'.
// 3. The 'requriedStatusType' key and value is required, the purpose is to tell the list is succes of failed.
// 4. Example : [
//   { requriedStatusType: 'success', status: '30ae8fff88', target: 'LICDBG000000000001', details: '263c0d8725' },
//   { requriedStatusType: 'error', status: 'd7c8c85bf7', target: 'LICDBG000000000002', details: '59ad6a86d2' },
// ]